import React from 'react';
import client from 'apollo/client';
import {Badge} from '@albert-io/atomic';

import {
  CurrentUserPointsDocument,
  useCurrentUserPointsQuery
} from './PointsIndicator.queries.generated';

export const invalidateUserPoints = () => {
  client.refetchQueries({include: [CurrentUserPointsDocument]});
};

const PointsIndicator = () => {
  const {data} = useCurrentUserPointsQuery({fetchPolicy: 'cache-and-network'});

  const pointsEarned = data?.currentUser?.pointsEarned;

  if (pointsEarned == null) {
    return <div />;
  }

  return (
    <Badge emphasis='bold' status='info'>
      {pointsEarned} pts
    </Badge>
  );
};

export default PointsIndicator;
